import { UpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.template';
import { IUpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.interface';
import { Component } from '@angular/core';
import { PRODUCTS_OF_PROVIDER_TTL_ES } from '../../../products-of-provider.interface';
import { FormBuilder, Validators } from '@angular/forms';
import { ProductsOfProviderService } from '../../../products-of-provider.service';
import { IRegulatedProduct } from 'src/app/pages/gestion/regulated-products/regulated-product.interface';
import { IProductUnregulated } from 'src/app/pages/gestion/products-unregulated/product-unregulated.interface';

enum TYPE_PRODUCT {
  REGULATED = 1,
  UNREGULATED = 2
}
@Component({
  selector: 'pg-products-of-provider-update',
  templateUrl: './products-of-provider-update.component.html'
})
export class ProductsOfProviderUpdateComponent
  extends UpdateTemplate
  implements IUpdateTemplate
{
  changeForm = false;
  select = {
    unitMeasure: {
      type: 'single',
      openDialog: false,
      id: null
    },
    provider: {
      type: 'single',
      openDialog: false,
      id: null
    },
    product: {
      type: 'single',
      REGULATED: {
        openDialog: false,
        id: null
      },
      UNREGULATED: {
        openDialog: false,
        id: null
      },
      data: null
    }
  };

  PRODUCTS_TYPES_NAMES_FOR_DROPDOWN = [
    { label: 'REGULADOS', value: 'REGULATED' },
    { label: 'NO REGULADOS', value: 'UNREGULATED' }
  ];

  constructor(
    private fb: FormBuilder,
    private productsOfProviderService: ProductsOfProviderService
  ) {
    super(PRODUCTS_OF_PROVIDER_TTL_ES, productsOfProviderService);
  }

  ngOnInit() {
    const item = this.row;

    this.fg = this.fb.group({
      code: [
        item.code,
        [Validators.minLength(3), Validators.maxLength(10)]
      ],
      description: [
        item.description,
        [Validators.required, Validators.minLength(5), Validators.maxLength(50)]
      ],
      unitMeasure: [
        { value: item.unitMeasureDescription, disabled: true },
        [Validators.required]
      ],
      provider: [
        { value: item.providerName, disabled: true },
        [Validators.required]
      ],
      productType: [TYPE_PRODUCT[item.typeProductId], [Validators.required]],
      product: [
        { value: `${item.codeProduct} - ${item.nameProduct}`, disabled: true },

        [Validators.required]
      ]
    });
    this.select.unitMeasure.id = item.unitMeasureId;
    this.select.provider.id = item.providerId;

    if (item.typeProductId === TYPE_PRODUCT.UNREGULATED) {
      this.select.product.UNREGULATED.id = item.productUnregulatedId;
    } else if (item.typeProductId === TYPE_PRODUCT.REGULATED) {
      this.select.product.REGULATED.id = item.productRegulatedId;
    }

    this.fg.valueChanges.subscribe(() => {
      this.changeForm = true;
    });
  }

  onSubmit(): void {
    if (this.fg.valid && this.changeForm) {
      const parsedForm = this.parseData(this.fg.value);

      this.updateItem$(parsedForm);
    }
  }

  parseData(form) {
    let productUnregulatedId = null;
    let productRegulatedId = null;
    if (form.productType === 'UNREGULATED') {
      productUnregulatedId = this.select.product.UNREGULATED.id;
    } else if (form.productType === 'REGULATED') {
      productRegulatedId = this.select.product.REGULATED.id;
    }
    const payload = {
      code: form.code,
      description: form.description,
      typeProductId: TYPE_PRODUCT[form.productType],
      providerId: this.select.provider.id,
      unitMeasureId: this.select.unitMeasure.id,
      productUnregulatedId: productUnregulatedId,
      productRegulatedId: productRegulatedId
    };
    if (payload.code === null || payload.code === '') delete payload.code;
    return payload;
  }

  onSelectedUnitMeasure(row) {
    if (row) {
      this.fg.get('unitMeasure').setValue(row.description);
      this.select.unitMeasure.id = row.id;
    }
    this.select.unitMeasure.openDialog = false;
  }

  onSelectedProvider(row) {
    if (row) {
      this.fg.get('provider').setValue(row.name);
      this.select.provider.id = row.id;
    }
    this.select.provider.openDialog = false;
  }

  onSelectedRegulatedProduct(row: IRegulatedProduct) {
    if (row) {
      this.select.product.data = row;
      this.fg.controls.product.setValue(`${row.code} - ${row.name}`);
      this.fg.get('description').setValue(row.name);
      this.select.product.REGULATED.id = row.id;
    }
    this.select.product.REGULATED.openDialog = false;
  }

  onSelectedUnregulatedProduct(row: IProductUnregulated) {
    if (row) {
      this.select.product.data = row;
      this.fg.controls.product.setValue(`${row.code} - ${row.name}`);
      this.fg.get('description').setValue(row.name);
      this.select.product.UNREGULATED.id = row.id;
    }
    this.select.product.UNREGULATED.openDialog = false;
  }

  openDialogByProductType() {
    this.select.product[this.fg.get('productType').value].openDialog = true;
  }

  onDropdownChanged() {
    this.fg.get('product').setValue(null);
  }
}
